import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Header from "../../components/NewHeader/NewHeader";
import Footer from "../../components/Footer";

import {
  MainContainer,
  HeaderWrapper,
  DropDownContainer,
  LabelRow,
  DropDownTitle,
  DropDownLightText,
  ContainerColumn,
  Chevron,
  Button,
  DropDownContent,
  ColumnDiv,
  SubTitle,
  Row,
  ChevronLeft,
  BackContainer,
  FooterContainer,
  Column,
  Total,
  Vat,
  Price,
  StyledRow,
  TextArea,
  ItemContainer,
  ItemsColumn,
  ItemPhoto,
  ItemName,
  ItemLabel,
  ItemPrice,
  ItemColumn,
  ItemSpecifications,
  ItemProduction,
  ItemRow,
  ItemQuantity,
  Fade,
  Notes,
  SmallButton,
  SmallButtons,
  FadeInOut,
  Input,
  FooterText,
  ButtonDisabled,
  ImgContainer,
  LoaderContainerPhoto,
  ImageContainerRow,
  Colors,
  Color,
  Size,
  SizeValue,
  StyledContainer,
} from "./OpsPage.styles";

import { blobUrlToFile, formatDate, priceFormatter } from "../../utils/utils";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GoogleMap,
  Marker,
  StandaloneSearchBox,
  useJsApiLoader,
} from "@react-google-maps/api";
import MiniLoader from "../../components/MiniLoader/MiniLoader";

import {
  DEFAULT_LATITUDE,
  DEFAULT_LONGITUDE,
  getCurrencySymbol,
  googlePlacesKey,
  MAP_LIBRARIES,
  MAP_ZOOM_LEVEL,
} from "../../utils/constants";
import {
  addDesignerNote,
  addPackageNote,
} from "../../store/slices/marketplace/asyncThunks";
import { useDispatch } from "react-redux";
import {
  cartItemsData,
  removeCartItem,
  resetCreateOrderDataOpsPortal,
  selectCreateOrderOpsPortal,
  selectGeneratePhotosWithLogoPending,
} from "../../store/slices/marketplace/marketplaceSlice";
import { selectBusinessUserInfo } from "../../store/slices/businessUser/slice";
import marketplaceService from "../../api/services/marketplace";
import openToast from "../../utils/toast";
import { isValidPhoneNumber } from "libphonenumber-js";
import PhoneNumberInput from "../../components/PhoneNumberInput/PhoneNumberInput";
import Loader from "../../components/Loader/Loader";
import AppLoader from "../../components/AppLoader";

const OpsCreateOrder = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const items = useSelector(cartItemsData);

  const [headerVisible, setHeaderVisible] = useState(true);
  const [lastScrollUpY, setLastScrollUpY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState(null);
  const lastScrollTopRef = useRef(0);
  const toastId = useRef(null);
  const lct = useLocation();
  const [createLoading, setCreateLoading] = useState(false);
  const generatePhotosWithLogoPending = useSelector(
    selectGeneratePhotosWithLogoPending
  );

  const [isVisiblePhotoLoader, setIsVisiblePhotoLoader] = useState(
    generatePhotosWithLogoPending
  );

  useEffect(() => {
    let timer;
    if (generatePhotosWithLogoPending) {
      setIsVisiblePhotoLoader(true);
    } else {
      timer = setTimeout(() => setIsVisiblePhotoLoader(false), 850);
    }

    return () => clearTimeout(timer);
  }, [generatePhotosWithLogoPending]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;
      const lastScrollTop = lastScrollTopRef.current;

      if (currentScrollTop === 0) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
        setScrollDirection(null);
        lastScrollTopRef.current = currentScrollTop;
        return;
      }

      if (currentScrollTop > lastScrollTop) {
        setScrollDirection("down");
        setLastScrollUpY(currentScrollTop);
      } else {
        setScrollDirection("up");
      }

      if (scrollDirection === "up" && currentScrollTop < lastScrollUpY - 350) {
        setHeaderVisible(true);
        setLastScrollUpY(currentScrollTop);
      }

      if (
        scrollDirection === "down" &&
        currentScrollTop > lastScrollUpY + 350
      ) {
        setHeaderVisible(false);
      }

      lastScrollTopRef.current = currentScrollTop;
    };

    const handleScrollDebounced = () => {
      requestAnimationFrame(handleScroll);
    };

    window.addEventListener("scroll", handleScrollDebounced);

    return () => {
      window.removeEventListener("scroll", handleScrollDebounced);
    };
  }, [scrollDirection]);

  const [show, setShow] = useState("");
  const [isVisible, setIsVisible] = useState("");

  useEffect(() => {
    let timer;
    if (show) {
      timer = setTimeout(() => setIsVisible(show), 150);
    } else {
      timer = setTimeout(() => setIsVisible(""), 150);
    }

    return () => clearTimeout(timer);
  }, [show]);

  useEffect(() => {
    if (lct.state && lct.state.openDetails) {
      setShow("order-details");
    }
  }, []);

  const createOrderOpsPortal = useSelector(selectCreateOrderOpsPortal);

  const searchBoxRef = useRef(null);
  const [mapZoom, setMapZoom] = useState(MAP_ZOOM_LEVEL);
  const mapRef = useRef();
  const [location, setLocation] = useState(createOrderOpsPortal.location);
  const [companyName, setCompanyName] = useState(
    createOrderOpsPortal.companyName
  );
  const [userName, setUserName] = useState(createOrderOpsPortal.userName);
  const [email, setEmail] = useState(createOrderOpsPortal.email);
  const [mobile, setMobile] = useState(createOrderOpsPortal.mobile);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googlePlacesKey,
    libraries: MAP_LIBRARIES,
  });

  const center =
    location?.lat && location?.lng
      ? {
          lat: location.lat,
          lng: location.lng,
        }
      : {
          lat: DEFAULT_LATITUDE,
          lng: DEFAULT_LONGITUDE,
        };

  const handlePlacesChanged = (map) => {
    const places = searchBoxRef.current?.getPlaces();

    if (places && places.length > 0) {
      const place = places[0];
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const address = place.formatted_address;
      setLocation({ lat, lng, address });

      if (mapRef.current) {
        mapRef.current.setCenter({ lat, lng });
        setMapZoom(14);
      }
    }
  };

  const handleMarkerDragEnd = (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results?.length > 0) {
        const address = results[0].formatted_address;
        setLocation({ lat, lng, address });
      }
    });
  };

  const handleMapClick = (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results?.length > 0) {
        const address = results[0].formatted_address;
        setLocation({ lat, lng, address });
      }
    });
  };

  const onLoad = useCallback(
    function callback(map) {
      mapRef.current = map;
      map.setCenter(center);
      map.setZoom(MAP_ZOOM_LEVEL);
    },
    [center]
  );

  const [notes, setNotes] = useState({});
  const [showNotes, setShowNotes] = useState({});
  const [packageNotes, setPackageNotes] = useState({});
  const [showPackageNotes, setShowPackageNotes] = useState({});

  const handleAddNote = (id, event, type) => {
    const { value } = event.target;
    if (type === "package") {
      setPackageNotes((prev) => ({
        ...prev,
        [id]: value,
      }));
    } else {
      setNotes((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const hideNotesComponent = (id, type) => {
    if (type === "package") {
      setShowPackageNotes((prev) => ({
        ...prev,
        [id]: false,
      }));
    } else {
      setShowNotes((prev) => ({
        ...prev,
        [id]: false,
      }));
    }
  };

  const handleSaveNote = (id, type) => {
    if (type === "package") {
      dispatch(addPackageNote({ id, body: { note: packageNotes[id] } }));
    } else {
      dispatch(addDesignerNote({ id, body: { note: notes[id] } }));
    }
  };

  const containerHeight = items?.length > 2 ? 985 : 596;

  const totalPrice = items.reduce((acc, item) => {
    return acc + item.itemPrice * item.quantity;
  }, 0);

  const businessUser = useSelector(selectBusinessUserInfo);

  const remove = (index) => {
    dispatch(removeCartItem({ index, businessUserId: businessUser.id }));
  };

  const checkIfPackaging = () => {
    let packagingExist = false;
    let existAnotherItems = false;

    for (const item of items) {
      if (item.isPackaging) {
        packagingExist = true;
      } else if (item.id) {
        existAnotherItems = true;
      }
    }
    return { packagingExist, existAnotherItems };
  };

  const validation = () => {
    if (!userName) {
      openToast(
        toastId,
        "delivery-details",
        "error",
        t("full-name-is-required")
      );
      return;
    }

    if (!mobile) {
      openToast(
        toastId,
        "delivery-details",
        "error",
        t("phone-number-is-required")
      );
      return;
    } else if (!isValidPhoneNumber(mobile)) {
      openToast(
        toastId,
        "delivery-details",
        "error",
        t("invalid-phone-number")
      );
      return;
    }

    if (!location.address) {
      openToast(toastId, "delivery-details", "error", t("address-is-required"));
      return;
    }

    if (!items.length) {
      openToast(toastId, "delivery-details", "error", t("add items to order"));
      return;
    }

    return true;
  };

  const handleCreateOrder = async () => {
    try {
      setCreateLoading(true);
      const formData = new FormData();

      formData.append("totalPrice", totalPrice);

      //subtotal
      formData.append("fullPrice", totalPrice);
      if (location.lat) {
        formData.append("locationLat", location.lat);
      }
      if (location.lng) {
        formData.append("locationLng", location.lng);
      }
      if (location.address) {
        formData.append("locationName", location.address);
      }
      if (mobile) {
        formData.append("mobilePhone", mobile);
      }
      if (userName) {
        formData.append("fullName", userName);
      }
      if (email) {
        formData.append("customerEmail", email);
      }
      if (companyName) {
        formData.append("customerCompanyName", companyName);
      }

      formData.append("dateOfDelivery", new Date().getTime());
      formData.append("isLoggedIn", businessUser.loggedIn);

      formData.append("paymentType", "BANK_TRANSFER");
      formData.append("createWithoutPayment", "true");

      let imageIndex = 0;
      for (const item of items) {
        if (item.isPackaging) {
          // formData.append("packageId", item.id);

          // if (item.packageLogo) {
          //   formData.append(
          //     "packageLogo",
          //     await blobUrlToFile(item.packageLogo, item.packageLogoName)
          //   );
          // }
          // if (item.packageColor) {
          //   formData.append("packageColor", item.packageColor);
          // }
          // if (item.quantity) {
          //   formData.append("packageQuantity", item.quantity);
          // }
          let itemObj = {
            id: item.id,
            isPackaging: true,
            quantity: item.quantity,
            packageColor: item.packageColor,
          };
          if (item.packageLogo) {
            formData.append(
              "files",
              await blobUrlToFile(item.packageLogo, item.packageLogoName)
            );
            itemObj.logoUrl = imageIndex;
            imageIndex += 1;
          }

          formData.append("items[]", JSON.stringify(itemObj));
        } else {
          let subcategoryItems = [];
          if (item.color.id) {
            subcategoryItems.push(item.color.id);
          }
          if (item.size.id) {
            subcategoryItems.push(item.size.id);
          }
          if (item.giftCard.id) {
            subcategoryItems.push(item.giftCard.id);
            formData.append("giftCardItemPrice", item.giftCard.price);
          }

          let itemObj = {
            id: item.id,
            printedItem: item.buyPrinted,
            sampleItem: item.buyBlank,
            quantity: item.quantity,
            printedQuantity: item.printedQuantity,
            sampleQuantity: item.sampleQuantity,
            subcategoryItems,
          };

          if (item.uploadLogoUrl) {
            formData.append(
              "files",
              await blobUrlToFile(item.uploadLogoUrl, item.uploadLogoName)
            );
            itemObj.logoUrl = imageIndex;
            imageIndex += 1;
          }
          if (item.photosWithLogo && item.photosWithLogo.length) {
            itemObj.photosWithLogo = item.photosWithLogo;
          }

          formData.append("items[]", JSON.stringify(itemObj));
        }
      }

      const result = await marketplaceService.createOrder(formData);
      if (result) {
        setCreateLoading(false);
        dispatch(resetCreateOrderDataOpsPortal());
        openToast(
          toastId,
          "delivery-details",
          "success",
          t("successfully-created-order")
        );

        navigate("/ops-portal");
      }
    } catch (err) {
      openToast(toastId, "delivery-details", "error", t(err?.message));
      setCreateLoading(false);
      console.log(err);
    }
  };

  const handleClickCreateButton = () => {
    // const { packagingExist, existAnotherItems } = checkIfPackaging();

    // if (items.length > 0 && existAnotherItems && !packagingExist) {
    //   const data = {
    //     userName,
    //     mobile,
    //     email,
    //     companyName,
    //     location,
    //   };
    //   dispatch(setCreateOrderDataOpsPortal(data));
    //   navigate("/ops-portal/packaging");
    // } else {
    if (validation()) {
      handleCreateOrder();
    }
    // }
  };

  return (
    <MainContainer>
      {createLoading && <Loader disableScroll></Loader>}

      <HeaderWrapper
        style={{
          opacity: headerVisible ? 1 : 0,
          marginTop: headerVisible ? 0 : -150,
          transition: "all 0.3s ease-in-out",
        }}
      >
        <Header />
      </HeaderWrapper>

      <StyledContainer>
        <ContainerColumn>
          <BackContainer onClick={() => navigate("/ops-portal")}>
            <ChevronLeft />
            <DropDownLightText style={{ color: "black" }}>
              {t("back")}
            </DropDownLightText>
          </BackContainer>

          <DropDownContent
            style={{
              minHeight: show === "order-details" ? containerHeight : 72,
            }}
          >
            <DropDownContainer
              onClick={() => {
                window.scrollTo(0, 0);
                if (show !== "order-details") {
                  setShow("order-details");
                } else {
                  setShow("");
                }
              }}
            >
              <LabelRow>
                <Chevron $open={show === "order-details"} />
                <DropDownTitle>{t("order-details")}</DropDownTitle>
              </LabelRow>
              <DropDownLightText>
                {t("order-date")}: {formatDate(new Date())}
              </DropDownLightText>
            </DropDownContainer>
            {isVisible === "order-details" && (
              <Fade $show={show === "order-details"}>
                <ItemsColumn>
                  {!!items?.length > 0 && (
                    <>
                      {items.map((product, index) => (
                        <ItemContainer key={product.id}>
                          <ImageContainerRow>
                            <ImgContainer>
                              {isVisiblePhotoLoader &&
                                product.cartItemId ===
                                  lct.state?.cartItemId && (
                                  <LoaderContainerPhoto>
                                    <AppLoader />
                                  </LoaderContainerPhoto>
                                )}
                              <ItemPhoto src={product?.photo?.url} />
                            </ImgContainer>

                            <Colors>
                              {product?.color?.name && (
                                <Color
                                  style={{
                                    backgroundColor: product.color.name,
                                    border: "1.2px solid #484888",
                                  }}
                                />
                              )}
                              {product?.size?.name && (
                                <Size>
                                  <SizeValue>{product.size.name}</SizeValue>
                                </Size>
                              )}
                            </Colors>
                          </ImageContainerRow>
                          <ItemColumn>
                            <ItemName>{product?.name}</ItemName>
                            <ItemLabel>
                              {t("quantity")}:
                              <ItemQuantity>{product?.quantity}</ItemQuantity>
                            </ItemLabel>
                            {!product?.buyBlank && !product?.buyPrinted ? (
                              <ItemPrice>
                                {!product?.productId && (
                                  <>
                                    <ItemSpecifications>
                                      {t("production")}:{" "}
                                    </ItemSpecifications>
                                    <ItemProduction>
                                      {product?.productionTime === 1 ? (
                                        <>
                                          {product?.productionTime}{" "}
                                          {t("business-day-small")}
                                        </>
                                      ) : (
                                        <>
                                          {product?.productionTime}{" "}
                                          {t("business-days-small")}
                                        </>
                                      )}
                                    </ItemProduction>
                                  </>
                                )}
                              </ItemPrice>
                            ) : product?.buyBlank && !product?.buyPrinted ? (
                              <ItemSpecifications>
                                {t("blank-sample")}
                              </ItemSpecifications>
                            ) : !product?.buyBlank && product?.buyPrinted ? (
                              <ItemSpecifications>
                                {t("printed-sample")}
                              </ItemSpecifications>
                            ) : null}
                          </ItemColumn>
                          <ItemColumn>
                            <ItemRow>
                              <ItemLabel>{t("price")}:</ItemLabel>
                              <ItemPrice>
                                {priceFormatter(product?.itemPrice)}{" "}
                                {getCurrencySymbol("sar")}
                              </ItemPrice>
                            </ItemRow>
                            <ItemRow>
                              <ItemLabel>{t("total-price")}</ItemLabel>
                              <ItemPrice>
                                {priceFormatter(
                                  product?.itemPrice * product?.quantity
                                )}{" "}
                                {getCurrencySymbol("sar")}
                              </ItemPrice>
                            </ItemRow>
                          </ItemColumn>

                          {product.isPackaging ? (
                            <>
                              {showPackageNotes[product?.id] && (
                                <FadeInOut
                                  $show={showPackageNotes[product?.id]}
                                >
                                  <Notes>
                                    <DropDownTitle>
                                      {t("designers-notes")}:
                                    </DropDownTitle>
                                    <TextArea
                                      onChange={(event) =>
                                        handleAddNote(
                                          product?.id,
                                          event,
                                          "package"
                                        )
                                      }
                                      value={packageNotes[product?.id] || ""}
                                    />
                                  </Notes>
                                  <SmallButtons>
                                    <SmallButton
                                      $cancel
                                      onClick={() =>
                                        hideNotesComponent(
                                          product?.id,
                                          "package"
                                        )
                                      }
                                    >
                                      Cancel
                                    </SmallButton>
                                    <SmallButton
                                      onClick={() =>
                                        handleSaveNote(product?.id, "package")
                                      }
                                    >
                                      Save
                                    </SmallButton>
                                  </SmallButtons>
                                </FadeInOut>
                              )}
                            </>
                          ) : (
                            <>
                              {showNotes[product.id] && (
                                <FadeInOut $show={showNotes[product.id]}>
                                  <Notes>
                                    <DropDownTitle>
                                      {t("designers-notes")}:
                                    </DropDownTitle>
                                    <TextArea
                                      onChange={(event) =>
                                        handleAddNote(
                                          product.id,
                                          event,
                                          "product"
                                        )
                                      }
                                      value={notes[product.id] || ""}
                                    />
                                  </Notes>
                                  <SmallButtons>
                                    <SmallButton
                                      $cancel
                                      onClick={() =>
                                        hideNotesComponent(product.id)
                                      }
                                    >
                                      Cancel
                                    </SmallButton>
                                    <SmallButton
                                      onClick={() =>
                                        handleSaveNote(product.id, "product")
                                      }
                                    >
                                      Save
                                    </SmallButton>
                                  </SmallButtons>
                                </FadeInOut>
                              )}
                            </>
                          )}
                          <FooterText
                            onClick={() => remove(index)}
                            style={{ cursor: "pointer" }}
                          >
                            {t("remove")}
                          </FooterText>
                        </ItemContainer>
                      ))}
                    </>
                  )}
                </ItemsColumn>
                <Button onClick={() => navigate("/ops-portal/marketplace")}>
                  {t("add-items")}
                </Button>
                <FooterContainer>
                  <Column>
                    <StyledRow>
                      <Total>{t("total")}</Total>
                      {totalPrice ? (
                        <Price>
                          {priceFormatter(totalPrice)}{" "}
                          {getCurrencySymbol("sar")}
                        </Price>
                      ) : (
                        <Price>
                          0 <Price>{getCurrencySymbol("sar")}</Price>
                        </Price>
                      )}
                    </StyledRow>
                    <Vat>{t("inclusive-of-vat")}</Vat>
                  </Column>
                </FooterContainer>
              </Fade>
            )}
          </DropDownContent>

          <DropDownContent
            style={{ minHeight: show === "customer-details" ? 596 : 72 }}
          >
            <DropDownContainer
              onClick={() => {
                window.scrollTo(0, 0);

                if (show !== "customer-details") {
                  setShow("customer-details");
                } else {
                  setShow("");
                }
              }}
            >
              <LabelRow>
                <Chevron $open={show === "customer-details"} />
                <DropDownTitle>{t("customer-details")}</DropDownTitle>
              </LabelRow>
            </DropDownContainer>

            {isVisible === "customer-details" && (
              <Row $show={show === "customer-details"}>
                <ColumnDiv>
                  <Input
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                    }}
                    placeholder={t("company-name")}
                  />
                  <Input
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder={t("user-name")}
                  />
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t("email")}
                    id="email"
                    name="email"
                    $noCapitalize
                  />

                  <PhoneNumberInput
                    phone={mobile}
                    placeholder={t("mobile")}
                    setPhone={setMobile}
                    containerStyle={{
                      width: "41rem",
                      fontSize: "1.6rem",
                      fontFamily: "Avenir",
                      letterSpacing: -0.178,
                    }}
                  />
                </ColumnDiv>
                <ColumnDiv>
                  <StyledRow $noSpace>
                    <SubTitle>{t("location")}:</SubTitle>
                    <StandaloneSearchBox
                      onLoad={(ref) => {
                        searchBoxRef.current = ref;
                      }}
                      onPlacesChanged={handlePlacesChanged}
                    >
                      <Input
                        type="text"
                        placeholder={t("search-for-location")}
                        value={location?.address}
                        onChange={(e) => {
                          setLocation((prevLocation) => ({
                            ...prevLocation,
                            address: e.target.value,
                          }));
                        }}
                      />
                    </StandaloneSearchBox>
                  </StyledRow>

                  {isLoaded ? (
                    <GoogleMap
                      mapContainerClassName="map"
                      mapContainerStyle={{
                        border: "1px solid white",
                        width: "100%",
                        maxWidth: 800,
                        height: 400,
                        borderRadius: 15,
                        boxShadow:
                          "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                      }}
                      onLoad={(map) => {
                        mapRef.current = map;
                        onLoad(map);
                      }}
                      zoom={mapZoom}
                      onClick={handleMapClick}
                    >
                      <Marker
                        position={
                          location?.lat && location?.lng
                            ? {
                                lat: location.lat,
                                lng: location.lng,
                              }
                            : {
                                lat: DEFAULT_LATITUDE,
                                lng: DEFAULT_LONGITUDE,
                              }
                        }
                        draggable
                        onDragEnd={handleMarkerDragEnd}
                      />
                    </GoogleMap>
                  ) : (
                    <div style={{ marginTop: 50 }}>
                      <MiniLoader />
                    </div>
                  )}
                </ColumnDiv>
              </Row>
            )}
          </DropDownContent>

          <DropDownContent
            style={{
              minHeight: show === "customer-uploads" ? 298 : 72,
              gap: 10,
            }}
          >
            <DropDownContainer
              onClick={() => {
                window.scrollTo(0, 0);
                if (show !== "customer-uploads") {
                  setShow("customer-uploads");
                } else {
                  setShow("");
                }
              }}
            >
              <LabelRow>
                <Chevron $open={show === "customer-uploads"} />
                <DropDownTitle>{t("customer-uploads")}</DropDownTitle>
              </LabelRow>
            </DropDownContainer>
          </DropDownContent>

          {items?.length > 0 && checkIfPackaging().existAnotherItems ? (
            <Button
              onClick={() => {
                handleClickCreateButton();
              }}
            >
              {t("create-order")}
            </Button>
          ) : (
            <ButtonDisabled>{t("create-order")}</ButtonDisabled>
          )}
        </ContainerColumn>
      </StyledContainer>

      <Footer />
    </MainContainer>
  );
};

export default OpsCreateOrder;
